import { MapUtils } from '../../utility/map-utils.js';
import { DayOfWeek } from './day-of-week.js';
import { DataModel, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../dto/dto.js';
import { BusinessHoursDay } from './business-hours-day.js';

export class BusinessHours extends DataModel {
  static readonly TYPE_ID: string = '48cea499ab5340d5a4fb72025e9fac2e';

  constructor(
    public readonly monday: BusinessHoursDay,
    public readonly tuesday: BusinessHoursDay,
    public readonly wednesday: BusinessHoursDay,
    public readonly thursday: BusinessHoursDay,
    public readonly friday: BusinessHoursDay,
    public readonly saturday: BusinessHoursDay,
    public readonly sunday: BusinessHoursDay,
  ) {
    super();
  }

  get $typeId() {
    return BusinessHours.TYPE_ID;
  }

  get hasAnyOpenHours(): boolean {
    return !this.monday.closed ||
        !this.tuesday.closed ||
        !this.wednesday.closed ||
        !this.thursday.closed ||
        !this.friday.closed ||
        !this.saturday.closed ||
        !this.sunday.closed;
  }

  nineToFive(): BusinessHours {
    return new BusinessHours(
        BusinessHoursDay.nineToFive(DayOfWeek.Monday),
        BusinessHoursDay.nineToFive(DayOfWeek.Tuesday),
        BusinessHoursDay.nineToFive(DayOfWeek.Wednesday),
        BusinessHoursDay.nineToFive(DayOfWeek.Thursday),
        BusinessHoursDay.nineToFive(DayOfWeek.Friday),
        BusinessHoursDay.nineToFive(DayOfWeek.Saturday),
        BusinessHoursDay.nineToFive(DayOfWeek.Sunday),
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessHours {
    return new BusinessHours(
        context.fromData<BusinessHoursDay>(MapUtils.getRaw(map, 'monday') as SerializedData),
        context.fromData<BusinessHoursDay>(MapUtils.getRaw(map, 'tuesday') as SerializedData),
        context.fromData<BusinessHoursDay>(MapUtils.getRaw(map, 'wednesday') as SerializedData),
        context.fromData<BusinessHoursDay>(MapUtils.getRaw(map, 'thursday') as SerializedData),
        context.fromData<BusinessHoursDay>(MapUtils.getRaw(map, 'friday') as SerializedData),
        context.fromData<BusinessHoursDay>(MapUtils.getRaw(map, 'saturday') as SerializedData),
        context.fromData<BusinessHoursDay>(MapUtils.getRaw(map, 'sunday') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'monday': context.toData(this.monday),
      'tuesday': context.toData(this.tuesday),
      'wednesday': context.toData(this.wednesday),
      'thursday': context.toData(this.thursday),
      'friday': context.toData(this.friday),
      'saturday': context.toData(this.saturday),
      'sunday': context.toData(this.sunday),
    };
  }

  clone(): this {
    return new BusinessHours(
        this.monday.clone(),
        this.tuesday.clone(),
        this.wednesday.clone(),
        this.thursday.clone(),
        this.friday.clone(),
        this.saturday.clone(),
        this.sunday.clone(),
    ) as this;
  }

  isSame(other: BusinessHours): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.monday, this.monday) &&
        isSameData(other.tuesday, this.tuesday) &&
        isSameData(other.wednesday, this.wednesday) &&
        isSameData(other.thursday, this.thursday) &&
        isSameData(other.friday, this.friday) &&
        isSameData(other.saturday, this.saturday) &&
        isSameData(other.sunday, this.sunday);
  }
}

export class BusinessHoursBuilder extends DataModelBuilder<BusinessHours> {
  build(context: SerializationContext, map: SerializedData): BusinessHours {
    return BusinessHours.fromMap(context, map);
  }
}
